<template>
  <div class="min-height-for-section  w-100 pt-livetv">
    <div class="px-0 px-md-4 container-fluid main-list-wrapper">
      <div class="main-list-section d-flex justify-content-center flex-column">
        <NewsMasthead />

        <!-- ads -->
        <div class="w-100 my-2 my-md-3">
          <billboardBannerTop v-if="desktop"></billboardBannerTop>
          <mrecBannerTop v-if="mobile"></mrecBannerTop>
        </div>

        <div
          class="w-100 my-4 px-2"
          v-for="(items, index) in categories_id"
          :key="'cat_id' + items"
        >
          <NewsRailsLandscape
            :cat_id="items"
            :datasource="'vod'"
            :cat="convertStringToLower(categories[index].replace(/\s/g, ''))"
            :title="categories[index]"
            v-if="index !== 6"
          />
          <div class="w-100" v-if="index == 2">
            <billboardBannerMiddle v-if="desktop"></billboardBannerMiddle>
            <mrecBannerMiddle v-if="mobile"></mrecBannerMiddle>
          </div>
        </div>
        <div class="w-100 my-4">
          <NewsSorotan
            :cat_id="10707"
            :datasource="'news'"
            :cat="'sorotan'"
            :title="'Sorotan'"
          />
        </div>
        <div class="w-100 my-4">
          <NewsLiputanSemasa
            :cat_id="10711"
            :datasource="'news'"
            :cat="'liputan-semasa'"
            :title="'Liputan Semasa'"
          />
        </div>
        <div class="w-100 my-4">
          <NewsSukan
            :cat_id="171"
            :datasource="'news'"
            :cat="'sukan'"
            :title="'Sukan'"
          />
        </div>
        <div class="w-100 my-4">
          <NewsDocumentary
            :cat_id="703"
            :datasource="'news'"
            :cat="'⁠dokumentari'"
            :title="'⁠Dokumentari'"
          />
        </div>

        <!-- ads -->
        <!-- <billboardBannerMiddle v-if="desktop"></billboardBannerMiddle>
      <mrecBannerMiddle v-if="mobile"></mrecBannerMiddle> -->

        <!-- ads bottom -->
        <div class="w-100 my-4">
          <BillboardBannerBottom v-if="desktop"></BillboardBannerBottom>
          <MrecBannerBottom v-if="mobile"></MrecBannerBottom>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import noimage from "../assets/noimage.png";
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
// ads
import billboardBannerTop from "../components/ads/v2/news/billboardBannerTop.vue";
import mrecBannerTop from "../components/ads/v2/news/mrecBannerTop.vue";
import billboardBannerMiddle from "../components/ads/v2/news/billboardBannerMiddle.vue";
import mrecBannerMiddle from "../components/ads/v2/news/mrecBannerMiddle.vue";
import BillboardBannerBottom from "../components/ads/v2/news/billboardBannerBottom.vue";
import MrecBannerBottom from "../components/ads/v2/news/mrecBannerBottom.vue";
import NewsMasthead from "../components/carousel/newsMasthead.vue";
import CategoryCarousel from "../components/categoryCarousel.vue";
import NewsDocumentary from "../components/carousel/news/newsDokumentari.vue";
import NewsSorotan from "../components/carousel/news/newsSorotan.vue";
import NewsLiputanSemasa from "../components/carousel/news/newsLiputanSemasa.vue";
import NewsSukan from "../components/carousel/news/newsSukan.vue";
// import VodCovidrails from "../components/carousel/vod/vodCovidrails.vue";
// import VodCovidPreventionRails from "../components/carousel/vod/vodCovidPreventionRails.vue";
import NewsRailsLandscape from "../components/rails/news_rails_landscape.vue";
export default {
  data: function() {
    return {
      vod: [],
      vod_mnn: [],
      vod_each: [],
      news: [],
      specials: [],
      trending: [],
      vod_episodes: [],
      noimage: noimage,
      mnnlink: "/play?scheme=205&p_type=true&id=1387&eps_id=",
      SpecialRailsId: "1387",
      SpecialRailsTitle: "COVID-19: MOH Press Conference",
      showvod_mnn: true,
      categories: ["⁠Berita Perdana (2026)", "⁠News at 10 (2026)", "⁠Berita Perdana (2025)", "⁠News at 10 (2025)"],
      categories_id: ["11632", "11633", "9705", "9706"],
      tablet: false,
      mobile: false,
      desktop: false,
    };
  },
  components: {
    billboardBannerTop: billboardBannerTop,
    mrecBannerTop: mrecBannerTop,
    billboardBannerMiddle: billboardBannerMiddle,
    mrecBannerMiddle: mrecBannerMiddle,
    BillboardBannerBottom,
    MrecBannerBottom,
    BreadCrumbsHeader,
    NewsMasthead,
    CategoryCarousel,
    // VodCovidrails,
    NewsRailsLandscape,
    NewsDocumentary,
    NewsSorotan,
    NewsLiputanSemasa,
    NewsSukan,
    // VodCovidPreventionRails,
  },
  methods: {
    imageLoadError(event) {
      event.target.src = noimage;
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        margin: 10,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            nav: true,
            stagePadding: 0,
          },
          600: {
            items: 2,
            nav: true,
            stagePadding: 0,
          },
          768: {
            items: 2,
            stagePadding: 0,
            loop: false,
          },
          991: {
            items: 5,
            stagePadding: 0,
            loop: false,
          },
        },
      });
    },
    installTrendingOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        margin: 10,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            nav: true,
            stagePadding: 0,
          },
          600: {
            items: 2,
            nav: true,
            stagePadding: 0,
          },
          991: {
            items: 3,
            stagePadding: 0,
            loop: false,
          },
        },
      });
    },
    imgFiltering(item) {
      var imgurl;
      //check if
      var checkThumbnail =
        item.data && item.data.images && item.data.images.thumbnail;
      var checkTitle = item.data && item.data.images && item.data.images.title;

      if (checkThumbnail) {
        imgurl =
          "https://rtb-images.glueapi.io/500x0/" +
          item.data.images.thumbnail.path;
      } else {
        if (checkTitle) {
          imgurl =
            "https://rtb-images.glueapi.io/500x0/" +
            item.data.images.title.path;
        } else {
          imgurl =
            "https://cdn-rtb.glueapi.io/v1/content/" +
            item.id +
            "/image/300x0/images.title";
        }
      }

      return imgurl;
    },

    goTo(link) {
      this.$router.push(link);
    },
    goToBanner(link) {
      this.$router.push(link);
    },
    checkLink(item) {
      var idSchema, check;
      var id = item.id;
      var title = item.data.title;

      var link;

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      }

      return link;
    },
    imageLoadError(event) {
      event.target.src = noimage;
    },
    convertStringToLower(items) {
      var strings;
      strings = items.toLowerCase();
      return strings;
    },
    initializepageview() {
      var self = this;
      // console.log(this.$route.path);
      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: this.$route.path,
          title: "vod",
          site: "RTBGo",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
  },

  mounted() {
    this.deviceCheck();
    if (!this.$route.params.id) {
      setTimeout(
        function() {
          this.initializepageview();
        }.bind(this),
        700
      );
    }
  },
};
</script>

<style scoped>
.main-list-wrapper {
  max-width: 100%;
}
.main-list-section {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: hidden;
}

.pt-livetv {
  padding: 20px 0 0;
  overflow: hidden;
}
.breadCrumbsWrapper {
  padding: 30px;
}

@media only screen and (max-width: 992px) {
  .main-list-section {
    overflow: unset;
  }
}

@media only screen and (max-width: 768px) {
  .main-list-wrapper {
    margin-top: 24px;
    margin-bottom: 24px !important;
  }

  .main-list-section {
    margin: -4% auto 0;
  }

  .pt-livetv {
    padding: 8px 0 0;
  }
  .breadCrumbsWrapper {
    padding: 16px;
  }
}
</style>
